module.exports = __webpack_public_path__ + "static/img/block.a2a5f5fe.png";